/**
 * Adresse de l'espace parent (app.zitelou.com), déduite de celle de l'API : la réinitialisation du mot de passe
 * se fait là-bas (c'est aussi là que pointe le lien du mail), pour la production comme pour la recette.
 *   https://api.zitelou.com/api          -> https://app.zitelou.com
 *   https://staging-api.zitelou.com/api  -> https://staging-app.zitelou.com
 */
export function parentAppUrl(apiUrl = process.env.REACT_APP_API_URL) {
  try {
    const { protocol, host } = new URL(apiUrl);
    const parentHost = host.replace(/^(staging-)?api\./, '$1app.');
    if (parentHost !== host) return `${protocol}//${parentHost}`;
  } catch {
    // adresse absente ou illisible : repli ci-dessous
  }
  return 'https://app.zitelou.com';
}
